import { z } from "zod";

/**
 * US-AE4.F7-1006 (bổ sung · @UC9948 @UC9949 · QĐ người dùng 05/10/2026) — ô tìm + khoảng ngày dùng chung cho các
 * danh sách của trang quỹ admin (Sổ quỹ, Yêu cầu nộp tiền). Một mảnh, hai tab — không khai lại luật ngày ở từng nơi.
 *
 *  - `q`: trim; rỗng sau trim ⇒ server coi như vắng. Server quyết khớp gì (tên người chỉ khi vai được xem tên).
 *  - `dateFrom` / `dateTo`: `YYYY-MM-DD` là NGÀY THẬT, hai đầu tính TRỌN ngày theo GIỜ VIỆT NAM (server đổi bằng
 *    `vnDayStartUtc` / `vnDayEndExclusiveUtc`). Một vế ⇒ chặn một phía. Từ > đến ⇒ 400 ở biên.
 */
export const ADMIN_LIST_SEARCH_MAX_LENGTH = 100;

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

function isRealDate(value: string): boolean {
  if (!ISO_DATE_RE.test(value)) return false;
  const ts = Date.parse(`${value}T00:00:00.000Z`);
  return !Number.isNaN(ts) && new Date(ts).toISOString().slice(0, 10) === value;
}

const isoDay = z.string().refine(isRealDate, "Ngày phải là YYYY-MM-DD và có thật");

export const adminListFilterShape = {
  // KHÔNG `z.preprocess`: bộ sinh OpenAPI coi ZodEffects là bắt buộc ⇒ spec ghi sai `q` required (review M3).
  // Rỗng sau trim vẫn hợp lệ ở biên; server coi là vắng (`adminListWindow`).
  q: z.string().trim().max(ADMIN_LIST_SEARCH_MAX_LENGTH).optional(),
  dateFrom: isoDay.optional(),
  dateTo: isoDay.optional(),
};

/** `dateFrom ≤ dateTo` (chuỗi ISO so được theo thứ tự từ điển). Gắn bằng `.superRefine` của schema chứa. */
export function refineAdminDayRange(
  v: { readonly dateFrom?: string | undefined; readonly dateTo?: string | undefined },
  ctx: z.RefinementCtx,
): void {
  if (v.dateFrom !== undefined && v.dateTo !== undefined && v.dateFrom > v.dateTo) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["dateTo"], message: "dateTo phải sau hoặc bằng dateFrom" });
  }
}
